import React from 'react';


const Cancel = ({width = '14px', height= '14px', color}) => {
    const getColor = (c) => {
        if (c === 'primary-500') return '#7F0689';
        if (c === 'secondary-500') return '#75D3A8';
        return c;
    };
    return (
        <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L1 9M1 1L9 9" stroke={getColor(color) || '#7F0689'} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
};
export default Cancel;
